import type { Id } from '@e-socna/data-layer';

import type { MappedReferencesContext } from '../../../../contexts/ReferencesContext';
import { HtmlViewer } from '../../../HtmlViewer';
import { formatAmount } from '../../../../utils/format-amount.util';
import { formatPercent } from '../../../../utils/format-percent.util';
import { formatQuantity } from '../../../../utils/format-quantity.util';
import type {
  DevisPrestationsCostAmountRenderModel,
  DevisPrestationsCostRenderModel,
} from '../utils/build-devis-prestations-render-model.util';

const formatCostAmount = (
  amount: DevisPrestationsCostAmountRenderModel,
  currenciesIdMap: MappedReferencesContext['currenciesIdMap'],
): string =>
  formatAmount(
    { value: amount.value, currencyId: amount.currencyId ?? ('' as Id) },
    currenciesIdMap,
  );

interface Props {
  readonly cost: DevisPrestationsCostRenderModel;
  readonly currenciesIdMap: MappedReferencesContext['currenciesIdMap'];
  readonly unitsIdMap: MappedReferencesContext['unitsIdMap'];
}

export const DevisPrestationsCostDetails = ({
  cost,
  currenciesIdMap,
  unitsIdMap,
}: Readonly<Props>) => (
  <div>
    {cost.code} — {cost.name}
    {cost.description ? <HtmlViewer html={cost.description} /> : null}
    <div>
      {'Prix unitaire HT : '}
      {formatCostAmount(cost.unitAmount, currenciesIdMap)}
      {' — Quantité : '}
      {formatQuantity(cost.quantity, unitsIdMap)}
      {' — Total HT avant marge : '}
      {formatCostAmount(cost.totalExcludingVatBeforeMargin, currenciesIdMap)}
      {' — Marge '}
      {cost.margin.label}
      {' par unité : '}
      {cost.margin.percentage === null
        ? formatCostAmount(cost.margin.amountPerUnit, currenciesIdMap)
        : formatPercent(cost.margin.percentage)}
      {' — Total HT avec marge : '}
      {formatCostAmount(cost.totalExcludingVatWithMargin, currenciesIdMap)}
    </div>
  </div>
);
